import React from "react";

import {trans, getCookie, removeCookie} from "../../../../common/utils";
import {CountdownTimer} from "../../../../common/hooks";

const SignUpForbidden = ({setFormPart}) => {
    const sec = parseInt(getCookie('signup-forbidden'));

    return <p className="simple-signup__text">{trans("You can try again in")}: {CountdownTimer({
        sec: sec ?? 900, onOver: () => {
            removeCookie('signup-forbidden');
            setFormPart(1);
        }
    })}</p>
};

export default SignUpForbidden;

